import { render, staticRenderFns } from "./Ips.vue?vue&type=template&id=3293820c&"
import script from "./Ips.vue?vue&type=script&lang=js&"
export * from "./Ips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports